<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Neues Buchungsextra
  section.modal-card-body
    b-select(v-model="selectedBookingExtra")
      option(v-for="extra in freeBookingExtras" :value="extra.id") {{extra.name}} {{extra.price / 100}}€
  footer.modal-card-foot
    button.button.is-primary(@click="$emit('selectExtra', selectedBookingExtra)") Auswählen
</template>

<script>
export default {
  props: {
    showBookingExtraModal: {
      type: Boolean,
      default: false
    },
    freeBookingExtras: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      selectedBookingExtra: this.freeBookingExtras[0].id
    };
  }
}
</script>

<style lang="scss" scoped>

</style>